import Axios from "axios";

const baseURL = process.env.BARRAMUNDI;

export default {
    async all(page = 1) {
        const response = await Axios.get(
            `${baseURL}communication/conversation?page=${page}`
        );
        return response.data.response;
    },
    async show(id) {
        const response = await Axios.get(
            `${baseURL}communication/conversation/${id}`
        );
        return response.data.response;
    },
    async update(id, data) {
        const response = await Axios.put(
            `${baseURL}communication/conversation/${id}`,
            data
        );
        return response.data.response;
    },
    async post(data) {
        const response = await Axios.post(
            `${baseURL}communication/conversation`,
            data
        );
        return response.data.response;
    },
    async delete(id, data) {
        const response = await Axios.delete(
            `${baseURL}communication/conversation/${id}`,
            data
        );
        return response.data.response;
    },
    async close(id, params) {
        const response = await Axios.post(
            `${baseURL}communication/close-conversation/${id}`,
            params
        );
        return response.data.response;
    },
    async move(newId, oldId) {
        const response = await Axios.post(
            `${baseURL}communication/move-conversation/${newId}/${oldId}`
        );
        return response.data.response;
    },
    async getUnread() {
        const response = await Axios.get(
            `${baseURL}communication/conversation/unread`
        );

        return response.data || [];
    }
};
